/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Info_item$ref = any;
type Info_seller$ref = any;
type Product_item$ref = any;
type QuickViewItem_item$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type Tile_item$ref = any;
export type Tile_item = {
    readonly isCustomizable: boolean | null;
    readonly isMultiSku: boolean;
    readonly serviceId: string | null;
    readonly localizedPdpUrl: string | null;
    readonly title: string | null;
    readonly vertical: VerticalType | null;
    readonly seller?: {
        readonly serviceId: string | null;
        readonly " $fragmentRefs": Info_seller$ref;
    } | null;
    readonly " $fragmentRefs": Info_item$ref & Product_item$ref & QuickViewItem_item$ref;
    readonly " $refType": Tile_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "Tile_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "isTrade",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "showSeller",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "showPrice",
                "type": "Boolean",
                "defaultValue": true
            },
            {
                "kind": "LocalArgument",
                "name": "pageDisplayEnum",
                "type": "PageDisplayEnum",
                "defaultValue": "searchAndBrowse"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isCustomizable",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isMultiSku",
                "args": null,
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "localizedPdpUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "vertical",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "FragmentSpread",
                "name": "Info_item",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isTrade",
                        "variableName": "isTrade"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageDisplayEnum",
                        "variableName": "pageDisplayEnum"
                    },
                    {
                        "kind": "Variable",
                        "name": "showPrice",
                        "variableName": "showPrice"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "Product_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "QuickViewItem_item",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "showSeller",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "seller",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Seller",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "FragmentSpread",
                                "name": "Info_seller",
                                "args": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '789578c9f8cd7cb98b133630c359a872';
export default node;
